import { render, staticRenderFns } from "./ProductCodeMessage.vue?vue&type=template&id=267f6858&scoped=true&"
import script from "./ProductCodeMessage.vue?vue&type=script&lang=js&"
export * from "./ProductCodeMessage.vue?vue&type=script&lang=js&"
import style0 from "./ProductCodeMessage.vue?vue&type=style&index=0&id=267f6858&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267f6858",
  null
  
)

export default component.exports